import { ButtonPrimary } from '@components/button/button-primary';
import { IconXCircle } from '@components/icons/icon-x-circle';
import classNames from 'classnames';

import { EmptyBlockProps } from './empty-block.type';

export const EmptyBlock = ({
  handleCta,
  ctaText,
  title,
  children,
  extraClasses,
  description,
  showCross,
}: EmptyBlockProps) => {
  return (
    <div className={classNames('flex flex-col items-center py-8', extraClasses)}>
      {children}
      {title && <h3 className='text-headline-s md:text-headline-m mb-1 md:mb-2 text-primary'>{title}</h3>}
      {description && (
        <p className='text-subtitle-s md:text-subtitle-m mb-0 text-center text-tertiary max-w-sm'>{description}</p>
      )}
      {handleCta && ctaText && (
        <ButtonPrimary onClick={handleCta} className='mt-8'>
          {showCross && <IconXCircle className='h-6 w-6 mr-2' />}
          {ctaText}
        </ButtonPrimary>
      )}
    </div>
  );
};
